export default "__VITE_ASSET__BTGqKZdv__"